import { useRef, useEffect, useCallback } from "react";
/**
 * 防抖hook
 */
const useDebounce = (fn: any, delay: number, dep = []) => {
  const { current } = useRef<any>({ fn, timer: null });
  useEffect(() => {
    current.fn = fn;
  }, [fn]);

  return useCallback((...args: any) => {
    if (current.timer) {
      clearTimeout(current.timer);
    }
    current.timer = setTimeout(() => {
      current.fn.call(this, ...args);
    }, delay);
  }, dep);
};

export default useDebounce;
